export const MODAL_STATUSES = {
  WARNING: "WARNING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
}
